<template>
    <v-menu :disabled="disabled" v-model="menu" :close-on-content-click="false">
        <template v-slot:activator="{on, attrs}">
            <v-text-field
                v-model="computedDateFormatted"
                :label="label"
                hint="DD/MM/YYYY format"
                persistent-hint
                append-icon="events"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                :disabled="disabled"
            >
            </v-text-field>
        </template>
        <v-date-picker v-model="date" :min="minDate" :max="maxDate"  @input="menu = false"></v-date-picker>
    </v-menu>
</template>
<style scoped>

</style>
<script>
import {formatDate} from '@/assets/js/common.js'
export default {
    name: 'datePicker',
    props: ["label", "disabled", "minDate", "maxDate"],
    data: () => ({
        menu: false,
        date: new Date().toISOString().substr(0, 10)
    }),
    computed: {
        computedDateFormatted () {
            this.$emit("dateFormatted", formatDate(this.date));
            return formatDate(this.date);
      }
    },
    methods: {
        setDate(newDate) {
            this.date = newDate;
        },
        resetDate() {
            this.date = new Date().toISOString().substr(0, 10);
        }
    }
}
</script>